<template>
    <div>
        <div class="Breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
                <el-breadcrumb-item>关于我们</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="tags">
            <div style="width: 7px;height: 7px;background-color: orange;"></div>
            <div style="width: 7px;height: 33px;background-color:#49aef1 ; margin-top: 6px;"></div>
            <div class="tag1">关于我们</div>
            <div class="triangle"></div>
            <div class="tag"></div>
            <hr>
           </div>
           <div class="ZDZX">
            <div class="img1"><img src="../img/20240307101123.png"></div>
            <div class="introduce"> 
                <h4>单位性质</h4>
                <hr>
                <span>根据《四川省教育厅关于转发直属事业单位机构职能编制规定的函》
(川教函[2021]94号)，四川省招生考试指导中心是
四川省教育厅直属、四川省教育考试院管理的事业单位。</span>
               <hr  style="background: linear-gradient(
        to left,
        transparent 0%,
        transparent 50%,
        #8ea4bb 50%,
        #8ea4bb 100%
    );
    background-size: 1rem 0.1rem; /* 第一个参数控制虚线的间隙（利用的是图片的放大效果一样），第二个参数控制虚线的粗细 */
    background-repeat: repeat-x;
    background-position: bottom; /* 控制方向：top、bottom */
    height:1px;width: 935px;margin-top: 10px;margin-bottom: 10px;">
              <h4>主要职责</h4>
              <hr>
              <span>彻执行《中华人民共和国教育法》《出版管理条例》等相关法律法规和政策标准，负责全省招生考试的指导咨询和政策宣传等工作，编辑、出版《招生考试报》《高校招生》《四川考试》《教育考试与评价》等报刊，完成四川省教育厅、四川省教育考试院交办的其他任务。</span>
            </div>
           </div>
           <div class="JXGS">
            <div class="img2"><img src="../img/9d2b6ad79f64fe787649ac67380fcaa.jpg"></div>
            <span >四川锦兴国试书业有限公司成立于2011年2月，是面向全川策划发行国家教育考试用书的专门机构，主营业务围绕我省各门类招生考试的工作展开，统一发行教育部考试院高等教育自学考试用书和我省普通高考、成人高考等考试用书。公司秉承“聚合考试精脉，服务四川考生”的宗旨，牢记“稳定可靠的图书质量是我们的生命，周到专业的服务是我们的责任，各界朋友们的支持与帮助是我们发展的基础”的初衷，全力做好考生、学校、各级招生考试机构的服务工作，努力做到社会效益和经济效益的共同发展</span>
           </div>
           <div class="tags">
            <div style="width: 7px;height: 7px;background-color: orange;"></div>
            <div style="width: 7px;height: 33px;background-color:#49aef1 ; margin-top: 6px;"></div>
            <div class="tag1">友情提示</div>
            <div class="triangle"></div>
            <div class="tag"></div>
            <hr>
           </div>
           <div class="tips">
            <p>考生下单前请仔阅读四川省教育考试院官网公布的四川省高等教育自学考试课表。</p>
           </div>
    </div>
</template>

<script>

</script>

<style scoped>
p{
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    float: left;
    margin: 20px;
    color: #a08b6b;
}
.tips{
    width: 1300px;
    border: 1px solid #f1eeee;
    height: 60px;
    margin-left: 250px;
    margin-top: 20px;
    float: left;
    border-radius: 8px;
    margin-bottom: 40px;
    background-color: #fdf4de;
}
.JXGS span{
    text-align: left;
    float: left;
    width: 1000px;
    margin-top: 40px;
    padding: 30px;
}
.img2{
    width: 290px;
    height: 260px;
    float: left;
    border: 1px solid #f1eeee;
    border-radius: 0 8px 8px 0;
}
.img2 img{
    width: 280px;
    height: 100px;
    margin-top: 80px;
}
.JXGS{
    width: 1300px;
    border: 1px solid #f1eeee;
    height: 260px;
    margin-left: 250px;
    margin-top: 20px;
    float: left;
    border-radius: 8px;
    margin-bottom: 40px;
}
span{
    font-size: 16px;
    color: #323f4d;
    line-height: 34px;
}
.introduce{
    padding: 30px;
    float: left;
    width: 1000px;
    text-align: left;
}
.introduce hr{
    width: 9%;
    margin-top: -5px;
    background: linear-gradient(to right, #b7ddf1, #ffffff);
    border: none ;
    height: 5px;
    margin-left: 0px;
    margin-bottom: 10px;
}
.ZDZX{
    width: 1300px;
    border: 1px solid #f1eeee;
    height: 300px;
    margin-left: 250px;
    margin-top: 20px;
    float: left;
    border-radius: 8px;
}
.img1 img{
    width: 280px;
    height: 140px;
    margin-top: 70px;
}
.img1{
    width: 290px;
    height: 300px;
    float: left;
    border: 1px solid #f1eeee;
    border-radius: 8px 0 0 8px;
}
.Breadcrumb{
    width: 1903px;
    height: 60px;
    background: #f5f6f6;
    float: left;
    margin-left: -20px;
    margin-top: -20px;
}
.el-breadcrumb{
    margin-top: 20px;
    margin-left: 270px;
    height: 60px;
    font-size: 16px;
    color: #c1c6c9;
    float: left;
}

hr{
    width: 1160px;
    margin-left: 140px;
    margin-top: -2px;
    border: 1px solid #efefef;
}
.tags{
    width: 1600px;
    float: left;
    height: 46px;
    margin-left: 250px;
    margin-top: 10px;
}
.tag1{
    font-size: 20px;
    color: #ffffff;
    width: 110px;
    height: 46px;
    margin-top: -46px;
    margin-left: 15px;
    position: relative;
    padding-top: 10px;
    background: linear-gradient(to top, #47a8f3,#6ac7f8);
}
.tag{
    width: 800px;
    float: left;
    height: 26px;
    margin-left: 138px;
    background-color: #efefef;
    margin-top: -35px;
    background: repeating-linear-gradient(145deg, white, white 2px, #efefef 2px, #efefef 4px) ;
    mask-image: linear-gradient(to left, transparent 0%, black 60%);
    transform: skew(19deg);
}
.triangle{
    width: 25px;
    height: 46px;                                       
    margin-left: 125px;
    clip-path: polygon(0 0, 0 100%, 50% 100%);
    margin-top: -46px;
    background: linear-gradient(to top, #47a8f3,#6ac7f8)
}
</style>
